<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <VSelect
      v-model="improvementInitiative.client"
      :label="$t('forms.labels.client')"
      outlined
      disabled
      :items="[client]"
    />
    <VSelect
      v-model="improvementInitiative.site"
      :label="$t('forms.labels.site')"
      outlined
      disabled
      :items="[site]"
      @change="onInput"
    />


    <VTextField
      v-model="improvementInitiative.massBalanceName"
      :label="$t('forms.labels.massBalanceName')"
      outlined
      disabled
      @change="onInput"
    />
    <VTextField
      v-model="improvementInitiative.projectName"
      :label="$t('forms.labels.projectName')"
      outlined
      :rules="{ required: true }"
      type="text"
      @change="onInput"
    />

    <VTextarea
      v-model="improvementInitiative.projectDescription"
      :label="$t('forms.labels.projectDescription')"
      outlined
      :rules="{ required: true, max: 500 }"
      type="text"
      @change="onInput"
    />


    <v-row>
      <v-col
        cols="6"
      >
        <VSelect
          v-model="improvementInitiative.waterSavingsUnit"
          :label="$t('massBalance.e4Form.improvementInitiative.waterSavingsUnit')"
          outlined
          :rules="{ required: true }"
          type="text"
          :items="waterSavingsUnits"
          @change="onInput"
        />
      </v-col>
    </v-row>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirty-changed', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('valid-changed', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import { WATER_SAVINGS_UNITS } from '@/aquassist-shared/constants/massBalance';

export default {
    name: 'ImprovementInitiative',
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VSelect,
        VTextField,
        VTextarea,
    },
    props: {
        massBalanceName: {
            type: String,
            default: null,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            improvementInitiative: {},
            isInitialized: false,
        };
    },

    computed: {
        ...mapGetters(['client', 'site', 'e4Config']),
        waterSavingsUnits() {
            return Object.values(WATER_SAVINGS_UNITS || {}).map(item => ({
                id: item,
                name: this.$t(`massBalance.e4Form.units.${item}`),
            }));
        },
    },
    created() {
        this.improvementInitiative = { ...this.e4Config.improvementInitiative } || {};
    },
    mounted() {
        this.onInput();
        this.$refs.observer.validate();

        this.isInitialized = true;
    },
    methods: {
        ...mapActions({
            setE4Config: 'setE4Config',
        }),
        async onInput() {
            if (this.isInitialized) {
                this.setE4Config({ improvementInitiative: this.improvementInitiative });
            }
        },
    },
};
</script>
